import { render, staticRenderFns } from "./EchangeRates.vue?vue&type=template&id=6f5e4d4e&"
import script from "./EchangeRates.vue?vue&type=script&lang=js&"
export * from "./EchangeRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports